// File: noviopus-ats-client/src/features/Dashboard/dashboardSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { 
  DashboardState, 
  DashboardViewMode, 
  ChartMetricType, 
  OrganizationSummary, 
  JobSummary,
  ChartDataPoint
} from './types';

export const initialState: DashboardState = {
  isLoading: false,
  viewMode: 'MULTI_ORG',
  metrics: {
    hires: { actual: 0, target: 0 },
  },
  activeChartMetric: 'hires',
  chartData: [],
  organizationsList: [],
  jobsList: [],
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    // Triggers Saga
    fetchDashboardData: (state) => {
      state.isLoading = true;
    },
    
    // Set View Context
    setDashboardViewMode: (state, action: PayloadAction<DashboardViewMode>) => {
      state.viewMode = action.payload;
    },

    // Data Success Handlers
    setMultiOrgDataSuccess: (state, action: PayloadAction<{
      orgs: OrganizationSummary[];
      totalHires: number;
      totalTarget: number;
      chartData: ChartDataPoint[];
    }>) => {
      state.isLoading = false;
      state.viewMode = 'MULTI_ORG';
      state.organizationsList = action.payload.orgs;
      state.jobsList = []; // Clear other view
      state.metrics.hires = { 
        actual: action.payload.totalHires, 
        target: action.payload.totalTarget 
      };
      state.chartData = action.payload.chartData;
    },

    setSingleOrgDataSuccess: (state, action: PayloadAction<{
      jobs: JobSummary[];
      totalHires: number;
      totalTarget: number;
      chartData: ChartDataPoint[];
    }>) => {
      state.isLoading = false;
      state.viewMode = 'SINGLE_ORG';
      state.jobsList = action.payload.jobs;
      state.organizationsList = []; // Clear other view
      state.metrics.hires = {
        actual: action.payload.totalHires,
        target: action.payload.totalTarget
      };
      state.chartData = action.payload.chartData;
    },

    setDashboardFailure: (state) => {
      state.isLoading = false;
    },

    // Chart Interaction
    setActiveChartMetric: (state, action: PayloadAction<ChartMetricType>) => {
      state.activeChartMetric = action.payload;
      // Saga will listen to this and refresh chart data if needed, 
      // or we handle it via selector if data is already loaded.
    },
    
    updateChartData: (state, action: PayloadAction<ChartDataPoint[]>) => {
        state.chartData = action.payload;
    }
  },
});

export const {
  fetchDashboardData,
  setDashboardViewMode,
  setMultiOrgDataSuccess,
  setSingleOrgDataSuccess,
  setDashboardFailure,
  setActiveChartMetric,
  updateChartData
} = dashboardSlice.actions;

export default dashboardSlice.reducer;